import Axios from "axios"
import { OrganizationDetail } from "./organization.type"
export const getOrganizationDetail = async (
  organization_id: string,
  loading: boolean = true
) => {
  return Axios.get<{ data: OrganizationDetail }>(
    `/api/organization/${organization_id}/detail?${loading ? "loading=0" : ""}`
  ).then((response) => {
    return response.data.data
  })
}

export const updateOrganization = async (
  organization_id: string,
  payload: {
    name: string
    address: string
    postal_code: string
    description: string
    phone_number: string
    website: string
    icon?: string
    bg_icon?: string
    is_upload_icon?: boolean
  }
) => {
  return Axios.put<{ data: OrganizationDetail }>(
    `/api/organization/${organization_id}/update?loading=0`,
    payload
  ).then((response) => {
    return response.data.data
  })
}

export const checkUserInWorkspace = async (ws_code: string) => {
  return Axios.post<{
    data: {
      check: boolean
      last_organization_db_name?: string | null
      new_token: string
    }
  }>(`/api/organization/check-user-in-workspace?loading=0`, { ws_code }).then(
    (response) => {
      return response.data.data
    }
  )
}
